import { useSelector } from 'react-redux';
import type { MpfPermissoes } from 'volto-ministerio-publico-federal/helpers/Permissoes';

/**
 * Permissões de interface do usuário autenticado, carregadas pelo
 * `MpfPermissoesLoader`. `null` enquanto não carregou ou para anônimo.
 */
export const useMpfPermissoes = (): MpfPermissoes | null =>
  useSelector((state: any) => state.mpfPermissoes?.data ?? null);

export default useMpfPermissoes;
